import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import noTasksImage from "../../../assets/no_tasks.svg";

const EmptyTaskList: React.FC = () => {
  const { t } = useTranslation(["dashboard"]);

  return (
    <Stack alignItems="center" justifyContent="center" spacing={3} sx={{ py: 6 }}>
      <img
        src={noTasksImage}
        alt="No tasks available"
        style={{
          width: "150px",
          height: "auto",
        }}
      />
      <Typography variant="body1" color="text.secondary" align="center" sx={{ fontSize: "1rem" }}>
        {t("dashboard:parent.myTasks.empty")}
      </Typography>
    </Stack>
  );
};

export default EmptyTaskList;
